<template>
<div v-if="$store.state.currentOrg" class="compact-view">

    <v-stepper v-if="!showSuccess" class="px-3 mx-2" flat :alt-labels="!$vuetify.breakpoint.xs" v-model="selectedStepper" :key="keyHeader" style="width:100%; padding:0; margin:0">
        <v-stepper-header class="elevation-0" style="height: 80px; margin: auto; margin-bottom: 10px" justify="center" >
                        <v-stepper-step v-for="(x, index) in stepHeaders" :key="index" mx-1 px-1 style="font-size: 12px" :complete="selectedStepper > index + 1" :step="index + 1"><span :style="{
                          color: 'grey',
                        }">{{ x.name }}</span></v-stepper-step>

        </v-stepper-header>
        <!-- All content -->
        <v-stepper-items flat style="width:100%">
              <v-stepper-content flat step="1" style="width:100%; padding:0; margin:0">
                <NetworkOperator @selectOperator="selectOperator"/>
            </v-stepper-content>
            <v-stepper-content flat step="2" style="width:100%; padding:0; margin:0">
                <AddressInfo v-if="detail.networkOperator" :networkOperator="detail.networkOperator" :location="location" @choosePackage="loadPackages" @showOfInterest="showOfInterest($event)" />
            </v-stepper-content>
            <v-stepper-content flat step="3" style="width:100%; padding:0; margin:0">
                <!-- <IspPackage :loading="loading" :key="loading" @back="selectedStepper --" :network="network" :packagesIsps="packagesIsps" :providerList="providerList" @proceed="packageSelected($event)" /> -->
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-text-field label="Search" v-model="searchPackages" clearable></v-text-field>
            </v-toolbar>
            <v-data-table
                v-model="selected"
                :headers="packageHeaders"
                :items="packagesIsps"
                :search="searchPackages"
                :rows-per-page-items="[10, 25, 50, 100]"
                item-key="id"
              >
                <template v-slot:items="props">
                  <tr
                    :active="props.selected"
                    @click="
                      props.selected = !props.selected;
                      onSelection();
                    "
                  >
                    <td>
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        @click="selected = []"
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-center">{{ props.item.customerOrganisation.name }}</td>
                    <td class="text-xs-center">{{ props.item.name }}</td>
                    <td class="text-xs-center">{{ props.item.term }}</td>
                    <td class="text-xs-center">
                      {{ props.item.onceOffPriceVatInc | currency }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.recurringPriceVatInc | currency }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.packagesFno.speedProfile.downloadMbps
                      }}<v-icon size="medium">arrow_downward</v-icon> {{ props.item.packagesFno.speedProfile.uploadMbps
                      }}<v-icon size="medium">arrow_upward</v-icon> Mbps
                    </td>
                    <td class="text-xs-center">
                      <v-chip color="light-green" class="white--text" v-if="props.item.isActive">Visible</v-chip>
                      <v-chip color="red" class="white--text" v-else>Not Visible</v-chip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-toolbar flat color="white">
                  <v-btn round color="primary" @click="selectedStepper --"><v-icon>chevron_left</v-icon> Back</v-btn>
                  <v-spacer></v-spacer>
                 
                  <v-btn round :disabled="!detail.selectedInternetPackage" color="primary" @click="selectedStepper ++">Next <v-icon>chevron_right</v-icon></v-btn>

              </v-toolbar>
            </v-stepper-content>
            <!-- <v-stepper-content flat step="4" style="width:100%; padding:0; margin:0">
                <ProductCards @back="selectedStepper --" :sizeScreen="$vuetify.breakpoint.name" :cardsPerPage="12" :productCards="productCards" @selectProduct="selectProduct" @proceed="proceedContact"></ProductCards>
            </v-stepper-content> -->
            <v-stepper-content flat step="4" style="width:100%; padding:0; margin:0">
                <Contact @back="selectedStepper --" :detail="detail" @proceed="proceedToSummary()" :showOfInterest="false"></Contact>
            </v-stepper-content>
            <v-stepper-content flat step="5" style="width:100%; padding:0; margin:0">
                <OrderSummary :productArray="[]" @back="selectedStepper--" @proceed="selectedStepper++" :detail="detail" :network="network" @submit="submitApplication()"/>
            </v-stepper-content>
        </v-stepper-items>

    </v-stepper>

    <div v-if="showSuccess">
        <Success :showOfInterest="stepperType=='showOfInterest'?true:false" />
    </div>

</div>
</template>

<script>
import AddressInfo from './AddressInfo.vue'
import Api from "@/services/Api.js";
import IspPackage from './Package.vue'
import ProductCards from "./ProductCards.vue";
import OrderSummary from "./OrderSummary.vue";
import NetworkOperator from "./NetworkOperator.vue";
import Contact from "./Contact.vue";
import Success from "./Success.vue";
import Summary from "./Summary.vue";
var disabledDates = [
    "2021-12-09",
    "2021-12-10",
    "2021-12-11",
    "2021-12-12",
    "2021-12-13",
    "2021-12-14",
    "2021-12-15",
    "2021-12-16",
    "2021-12-17",
    "2021-12-18",
    "2021-12-19",
    "2021-12-20",
    "2021-12-21",
    "2021-12-22",
    "2021-12-23",
    "2021-12-24",
    "2021-12-25",
    "2021-12-26",
    "2021-12-27",
    "2021-12-28",
    "2021-12-29",
    "2021-12-30",
    "2021-12-31",
    "2022-01-01",
    "2022-01-02",
    "2022-01-03",
    "2022-01-04",
    "2022-01-05",
    "2022-01-06",
    "2022-01-07",
    "2022-01-08",
    "2022-01-09"
];
export default {
    components: {
        AddressInfo,
        Contact,
        IspPackage,
        NetworkOperator,
        OrderSummary,
        ProductCards,
        Success,
        Summary
    },
    data() {
        return {

            detail: {
                primaryContact: {},
                secondaryContact: null,
                billingContact: null,
                address: {},
                selectedInternetPackage: {},
                isBusiness: false,
                billingAddressSame: true,
                isPropertyOwner: true,
                isPropertyTenant: false,
                internetPackageSelected: false,
                includeTVOverFibrePackage: false,
                activationDate: "",
                selectedInternetPackage: null,
                selectedNetwork: {},
                showSecondaryContact: false,
                addBillingContact: false,
                signature: null,
                isBusiness: false,
                organisationName: "",
            },
            packageHeaders: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "ISP",
          align: "center",
          value: "customerOrganisation.name",
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Term",
          align: "center",
          value: "term",
        },
        {
          text: "Once Off Price Vat Inc",
          align: "center",
          value: "onceOffPriceVatInc",
        },
        {
          text: "Recurring Price Vat Inc",
          align: "center",
          value: "recurringPriceVatInc",
        },
        {
          text: "Download/ Upload Speed",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps/packagesFno.speedProfile.uploadMbps",
        },
        {
          text: "Status",
          align: "center",
          value: "isActive",
        },
      ],
            searchPackages: '',
            keyHeader: 0,
            selected: [],
            key: 0,
            loading: false,
            location: null,
            network: null,
            packagesIsps: [],
            productArray: [],
            productCards: [],
            providerList: [],
            selectedStepper: 1,
            selectedPackage: null,
            showSuccess: false,
            stepHeaders: [
                {
                    name: "Network Operator",
                    card: "networkOperator"
                },{
                    name: "Address Info",
                    card: "chooseEstate"
                },
                {
                    name: "Package",
                    card: "choosePackage"
                },
                {
                    name: "Contact Info",
                    card: "chooseContact"
                },
                {
                    name: "Order Summary",
                    card: "chooseSummary"
                }
                // {
                //     name: "Submit",
                //     card: "chooseTerms"
                // },
            ],
            stepperType: 'standard'
        }
    },
    created() {
        // this.stepHeaders = this.standardStepHeaders
        //             setTimeout(() => {
        //                 this.selectedStepper=4
        //             }, 75)
        let days = 0
        if (this.$store.state.currentOrg.applicationNoticeDays) {
            days = parseInt(this.$store.state.currentOrg.applicationNoticeDays);
        }
        this.detail.minActivationDate = this.formatDate(this.addDays(new Date(), days));
        
        this.nextAvailableDay()
    },
    watch: {
        network(value){
            if(value){
                this.packagesIsps=[]
            }
        }
    },
    methods: {
        addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            result.toISOString();
            return result;
        },
        selectOperator(data){
            this.detail.networkOperator = data
            console.log(this.detail.networkOperator)
            this.selectedStepper ++
        },
        async loadPackages(network, address, type = 'Fibre') {
            this.loading = true
            this.network = network
            this.detail.address = address
            // this.stepHeaders = this.standardStepHeaders
            this.detail.selectedNetwork = network
            setTimeout(() => {
                this.selectedStepper++
            }, 75)
            this.packagesLoading = true;
            this.loadingText = "Fetching Packages Available on Selected Network...";
            if(this.detail.networkOperator.id == this.$store.state.currentOrg.id){
                Api()
                .get("/ftthApplication/byNetwork/active/" + this.network.id + "/" + type)
                .then(async (response) => {

                    this.keyHeader++
                    await response.data.activePackages.map(async (x) => {
                        x.isSelected = false;
                        x.customerOrganisation = await response.data.organisations.find((y) => y.id == x.customerOrganisationId);
                    });
                    this.packagesIsps = response.data.activePackages
                })
            } else {
Api()
        .get("/ftthApplication/isp/byNetwork/active/" + network.id + "/" + this.detail.networkOperator.id)
        .then((response) => {
          this.packagesIsps = response.data.activePackages;
        })
            }
             
            // Api()
            //     .get("/ftthApplication/byNetwork/active/" + this.network.id + "/" + type)
            //     .then(async (response) => {

            //         this.keyHeader++
            //         await response.data.activePackages.map(async (x) => {
            //             x.isSelected = false;
            //             x.customerOrganisation = await response.data.organisations.find((y) => y.id == x.customerOrganisationId);
            //         });
            //         this.packagesIsps = response.data.activePackages
            //         this.providerList = response.data.organisations
            //         // this.selectedStepper++
            //         this.fetchProducts(this.network.id)
            //             this.loading=false
            //         this.key++

            //     })
        },
        fetchProducts(id) {
            Api()
                .get("/ftthApplication/locationNetworkProduct/byNetwork/" + id)
                .then((response) => {
                    this.productCards = response.data;
                    if (this.productCards.length > 0) {
                        // this.stepperType = 'full'

                        // this.stepHeaders = this.fullStepHeaders
                        this.keyHeader++

                    }

                });
        },
        formatDate(date) {
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            if (dd < 10) {
                dd = "0" + dd;
            }
            if (mm < 10) {
                mm = "0" + mm;
            }
            var yyyy = date.getFullYear();
            var result = yyyy + "-" + mm + "-" + dd;
            return result;
        },
            onSelection() {
      this.detail.selectedInternetPackage = this.selected[0];
    },
        selectPackage() {
            console.log('package Selected')
        },
        selectProduct(data) {
            this.productArray = data
            this.detail.selectedProduct = this.productArray
        },
        nextAvailableDay(){
        console.log('Min Day: ', this.detail.minActivationDate)
        let dateSelected = false
        let startDate = new Date()
        while(!dateSelected){
            if(this.addDays(new Date(this.detail.minActivationDate),1)<startDate && !disabledDates.includes(this.formatDate(startDate))){
                dateSelected = true
                this.detail.activationDate = this.formatDate(startDate);
            } else {
                startDate = this.addDays(startDate, 1)
            }

        }
        console.log(this.detail.activationDate)

        },
        proceedContact() {
            this.selectedStepper++
        },
        packageSelected(data) {
            this.selectedPackage = data
            this.detail.selectedInternetPackage = data
            this.selectedStepper++
        },
        proceedToSummary() {
            this.selectedStepper++
        },
        showOfInterest(address) {
            this.detail.address = address
            // this.stepHeaders = this.showOfInterestHeaders
            this.stepperType = 'showOfInterest'
            setTimeout(() => {
                this.selectedStepper++
            }, 75)
        },
        submitShowOfInterest() {
            this.detail.showInterest = true
            this.detail.agreeShareDetails = true
            this.detail.leadType = 'Interest';
                this.detail.address.coordinates = null;
                if (this.detail.address.lat && this.detail.address.lng) {
                    this.detail.address.coordinates = JSON.stringify({
                        lat: this.detail.address.lat,
                        lng: this.detail.address.lng,
                    });
                }
                if (this.detail.selectedInternetPackage !== null) {
                    if (this.detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType == "Business") {
                        this.detail.isBusiness = true;
                    } else {
                        this.detail.isBusiness = false;
                    }
                }
                Api()
                    .post("/ftthApplication/lead", {
                        data: this.detail,
                    })
                    .then((response) => {
                        // this.chooseComplete = true;
                        // this.e1 = 0;
                        // this.$router.push({path: '/success'})
                        this.showSuccess = true
                    });
        },
        submitShowOfInterest() {
            this.detail.showInterest = true
            this.detail.agreeShareDetails = true
            this.detail.leadType = 'Interest';
                this.detail.address.coordinates = null;
                if (this.detail.address.lat && this.detail.address.lng) {
                    this.detail.address.coordinates = JSON.stringify({
                        lat: this.detail.address.lat,
                        lng: this.detail.address.lng,
                    });
                }
                if (this.detail.selectedInternetPackage !== null) {
                    if (this.detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType == "Business") {
                        this.detail.isBusiness = true;
                    } else {
                        this.detail.isBusiness = false;
                    }
                }
                Api()
                    .post("/ftthApplication/lead", {
                        data: this.detail,
                    })
                    .then((response) => {
                        // this.chooseComplete = true;
                        // this.e1 = 0;
                        // this.$router.push({path: '/success'})
                        this.showSuccess = true
                    });
        },
        submitApplication(){
            this.detail.address.coordinates = null;
                if (this.detail.address.lat && this.detail.address.lng) {
                    this.detail.address.coordinates = JSON.stringify({
                        lat: this.detail.address.lat,
                        lng: this.detail.address.lng,
                    });
                }
                if (this.detail.selectedInternetPackage !== null) {
                    if (this.detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType == "Business") {
                        this.detail.isBusiness = true;
                    } else {
                        this.detail.isBusiness = false;
                    }
                }
                 this.detail.supplierOrganisationId = this.detail.networkOperator.id
        this.detail.organisationId = this.detail.networkOperator.id
            this.detail.vat = this.$VAT;
             this.detail.showInterest = false
            this.detail.agreeShareDetails = true
            Api()
          .post("/ftthApplication/isp", {
            data: this.detail,
          })
          .then((response) => {
                        this.showSuccess = true
                        this.$emit('submitted')
                        // debugger
          })
          .catch((error) => {
                        const msg = error && error.response && error.response.data && error.response.data.message
                        alert(msg || 'The order could not be submitted. Please try again.')
          })
        }
    }

}
</script>
<style scoped>
</style>
